import { useCreateOAuthIntegration } from '@modules/integrationsV2/hooks';
import {
  IntegrationChannelType,
  IntegrationDirection,
} from 'generated/graphql';
import { useCallback } from 'react';
import { useGetUser, useGetUserSetter } from 'v2/core/services/user';
import { NAV_PATHS } from '../constants';

interface useConnectPrivateOutboundSlackIntegrationOptions {
  onSuccess?: () => void;
}

export const useConnectPrivateOutboundSlackIntegration = (
  opts?: useConnectPrivateOutboundSlackIntegrationOptions,
) => {
  const user = useGetUser();
  const setUser = useGetUserSetter();

  const onIntegrationCreation = useCallback(
    (id: string) => {
      setUser({
        ...user,
        notificationChannels: [
          ...(user?.notificationChannels ?? []),
          {
            id,
            direction: IntegrationDirection.PrivateOutbound,
            isActive: true,
            channel: {
              displayName: 'Slack',
              type: IntegrationChannelType.Slack,
            },
          },
        ],
      });
    },
    [setUser, user],
  );

  const isConnecting = useCreateOAuthIntegration({
    shouldRedirect: false,
    redirectUri: `/${NAV_PATHS.CONNECT_SLACK}`,
    onCompleted: (integrationID: string) => {
      onIntegrationCreation(integrationID);
      opts?.onSuccess?.();
    },
  });

  return isConnecting;
};
